export const AttributeMixin = {
    props: {
        animal: {type: Object, default: () => { return {} } },
        eventData: {type: Object, default: () => {return null } },
        eventId: {type: Number, default: null },  //  Необходимо для исключения лишней загрузки прикрепленных документов до загрузки данных основного объекта
        editable: { type: Boolean, default: true },
    },
    methods: {
        setObjectData(data) {
            this.objectData = data.attributes;
        },
        initialize() {
            if (this.animal) {
                this.initObjectParams = { labelId: this.animal.labelId, chipId: this.animal.chipId }
            }
            if (this.eventData) {
                this.objectData = this.eventData.attributes;
                this.initObjectParams['eventId'] = this.eventData['id'];
                this.initObjectParams['authorOrganizationId'] = this.eventData['author_organization_id'];
                this.initObjectParams['executorOrganizationId'] = this.eventData['executor_contract_object'] ? this.eventData['executor_contract_object']['contractor'] : null;
            }
        },
        isEditable(fieldName) {
            return this.getAbility(fieldName) && this.editable
        }
    },
}